<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Club (id {{clubId}})</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Club',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    clubId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
          route: {name: 'club_info', params: {clubId: this.clubId}},
        },
        {
          title: 'Members',
          route: {name: 'club_members', params: {clubId: this.clubId}},
        },
        {
          title: 'Chat',
          route: {name: 'club_chat', params: {clubId: this.clubId}},
        },
       
        /*
        {
          title: 'Chat copies',
          route: {name: 'club_chat_copies', params: {clubId: this.clubId}},
        },
        */
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 1em;
}
</style>
